// @flow
import React from 'react';
import _ from 'lodash';

import AbstractComponent from 'components/AbstractComponent';

import { RouteStore, ProAccountStore } from 'stores';
import { ProAccountAction } from 'actions';

import { Events } from 'constants';
import RoutingEnum from 'constants/RoutingEnum';

import Listener from 'PMT/flux/Listener';
import I18n from 'PMT/i18n/I18n';

export default class ForgotPasswordPage extends AbstractComponent {
  constructor() {
    super();

    this.state = {
      isSuccess: null,
      username: '',
    };
  }

  componentDidMount() {
    ProAccountStore.addListeners([
      new Listener(Events.PRO_FORGOT_PASSWORD, this.onForgotPassword),
    ]);
  }

  componentWillUnmount() {
    ProAccountStore.removeListeners([
      new Listener(Events.PRO_FORGOT_PASSWORD, this.onForgotPassword),
    ]);
  }

  onForgotPassword = () => {
    const meAccount = ProAccountStore.getMeAccount();
    this.setState({
      isSuccess: meAccount.forgotPassword,
    });

    if (meAccount.forgotPassword) {
      setTimeout(() => {
        RouteStore.redirectTo(RoutingEnum.LOGIN);
      }, 2000);
    }
  };

  onUsernameChange = () => {
    this.setState({
      username: this.refs.username.value,
    });
  };

  onSubmit = event => {
    this.setState({
      isSuccess: null,
    });
    event.preventDefault();
    ProAccountAction.forgotPassword(this.state.username);
  };

  render() {
    return (
      <form
        className="login_page__login_form form-horizontal"
        onSubmit={this.onSubmit}
      >
        <div className="row">
          <div className="col-xs-12 col-sm-8 col-sm-offset-2">
            <h2>{I18n.tr('forgot_password.title')}</h2>
            <h5 className="text-muted">
              {I18n.tr('forgot_password.description')}
            </h5>
            <input
              type="email"
              defaultValue={this.state.username}
              name="username"
              ref="username"
              placeholder={I18n.tr('forgot_password.email')}
              onChange={this.onUsernameChange}
              className="form-control big-form-control"
            />
            {!_.isNil(this.state.isSuccess) ? (
              <h5
                className={`text-${
                  this.state.isSuccess ? 'primary' : 'danger'
                }`}
              >
                {I18n.tr(
                  `forgot_password.${
                    this.state.isSuccess ? 'success' : 'failure'
                  }`
                )}
              </h5>
            ) : (
              <br />
            )}
            <button type="submit" className="btn btn-primary">
              {I18n.tr('forgot_password.submit')}
            </button>
          </div>
        </div>
      </form>
    );
  }
}
